import { motion, AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import styles from "./InfoPanel.module.css";
//https://brad-carter.medium.com/how-to-animate-a-text-reveal-effect-in-react-with-framer-motion-ae8ddd296f0d

const sentence = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.05,
      staggerChildren: 0.02,
    },
  },
};

const letter = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
  },
};

export default function InfoPanel({ currLesson }) {
  const [lessonWords, setLessonWords] = useState(null);
  const [titleText, setTitleText] = useState(null);
  const [subtitleText, setSubtitleText] = useState(null);
  const [numberText, setNumberText] = useState(null);

  useEffect(() => {
    setLessonWords(null);
    setTitleText(null);
    setSubtitleText(null);

    setTimeout(() => {
      setTitleText(currLesson.title);

      if (currLesson.subtitle) {
        setNumberText(`LESSON ${currLesson.number}`);
        setSubtitleText(currLesson.subtitle);
      }

      setLessonWords(currLesson.lesson.split(" "));
    }, 500);
  }, [currLesson]);

  return (
    <div className={styles.infoPanelHolder}>
      <div className={styles.InfoPanel}>
        <AnimatePresence>
          {titleText && (
            <motion.div
              variants={sentence}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              {subtitleText && (
                <h3 className={styles.lessonSubtitle}>{numberText}</h3>
              )}
              <h2 className={styles.lessonTitle}>{titleText}</h2>
              {subtitleText && (
                <h3 className={styles.lessonSubtitle}>{subtitleText}</h3>
              )}
            </motion.div>
          )}
        </AnimatePresence>

        {lessonWords && <AnimatedParagraph lessonWords={lessonWords} />}
      </div>
    </div>
  );
}

const AnimatedParagraph = ({ lessonWords }) => {
  return (
    <motion.div
      className={styles.lessonContent}
      variants={sentence}
      initial="hidden"
      animate="visible"
    >
      {lessonWords.map((word, index) => {
        if (word === "<br/>") {
          return (
            <span key={"break" + index} className={styles.paragraphBreak} />
          );
        } else {
          return (
            <motion.span key={word + "-" + index} variants={letter}>
              {word + " "}
            </motion.span>
          );
        }
      })}
    </motion.div>
  );
};
